import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Grid,
  Button,
  CssBaseline,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TextField,
  useTheme,
  Menu,
  MenuItem,Tooltip,
} from "@mui/material";
import { Close, Warehouse, ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { Warehouse_API_ENDPOINTS } from "../../../config/api/apiCallWarehouse";
import CallAlertBar from "../../../Layout/Alertbar";
import AddUpdateWarehousemapping from "./AddUpdateWarehousemapping";
import { useNavigate } from "react-router-dom";
import useUserPermissions from "../../../components/user-permission/UserPermission";
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import ModuleHelpDialog from "../../../components/ModuleHelpDialog";
import { moduleHelpData } from "../../../data/moduleHelpData";
import HelpIcon from '@mui/icons-material/HelpOutline';

const WarehouseMappingMasterIndex = ({ handleBackWinderMachineEntry }) => {
  const [mappingList, setMappingList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [filters, setFilters] = useState({
    region: "",
    package_type: "",
    warehouse_name: "",
    bin_type_name: "",
    status: "",
  });
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [alertMessage, setAlertMessage] = useState("");
  const [alertTitle, setAlertTitle] = useState("");

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
const userPermissions = useUserPermissions();
  // 🔽 Menu state
  const [anchorElFirst, setAnchorElFirst] = useState(null);
  const [selectedOptionFirst, setSelectedOptionFirst] = useState("All WH Mapping List");

  const openFirst = Boolean(anchorElFirst);
  
const [helpOpen, setHelpOpen] = useState(false);
    const handleCloseHelp = () => setHelpOpen(false);
    const handleHelpMenuClick = () => setHelpOpen(true);

  const handleMenuClickFirst = (event) => {
    setAnchorElFirst(event.currentTarget);
  };
  const handleMenuCloseFirst = () => {
    setAnchorElFirst(null);
  };

  // ✅ Menu Click Filter
const handleMenuItemClickFirst = (option) => {
  setSelectedOptionFirst(option);
  handleMenuCloseFirst();

  const normalizedList = mappingList.map((x) => ({
    ...x,
    statusText:
      typeof x.status === "string"
        ? x.status.toLowerCase()
        : x.status === true
        ? "active"
        : "inactive",
  }));

  if (option === "All WH Mapping List") {
    setFilteredList(mappingList);
  } else if (option === "Active Mapping List") {
    setFilteredList(normalizedList.filter((x) => x.statusText === "active"));
  } else if (option === "Inactive Mapping List") {
    setFilteredList(normalizedList.filter((x) => x.statusText === "inactive"));
  }
};


  // ✅ Load Warehouse Mapping List
  const loadWarehouseMappingList = () => {
    const payload = {
      p_companyid: localStorage.getItem("companyid"),
      p_plantid: 1,
      p_mapping_id: 0,
    };

    callApi(
      Warehouse_API_ENDPOINTS.warehousemapping.list,
      "POST",
      { "Content-Type": "application/json" },
      payload
    )
      .then((data) => {
        if (data && data.length > 0) {
          setMappingList(data);
          setFilteredList(data);
        } else {
          setMappingList([]);
          setFilteredList([]);
          setAlertSeverity("warning");
          setAlertTitle("Warning");
          setAlertMessage("No Warehouse Mapping data found!");
          setAlertOpen(true);
        }
      })
      .catch(() => {
        setMappingList([]);
        setFilteredList([]);
        setAlertSeverity("error");
        setAlertTitle("Error");
        setAlertMessage("Unable to load Warehouse Mapping data");
        setAlertOpen(true);
      });
  };

  useEffect(() => {
    loadWarehouseMappingList();
  }, []);

  // ✅ Apply Filters Dynamically
//   useEffect(() => {
//   const filtered = mappingList.filter((row) => {
//     const statusText =
//       typeof row.status === "string"
//         ? row.status.toLowerCase()
//         : row.status === true
//         ? "active"
//         : "inactive";

//     return (
//       (row.region || "").toLowerCase().includes(filters.region.toLowerCase()) &&
//       (row.package_type || "")
//         .toLowerCase()
//         .includes(filters.package_type.toLowerCase()) &&
//       (row.warehouse_name || "")
//         .toLowerCase()
//         .includes(filters.warehouse_name.toLowerCase()) &&
//       (row.bin_type_name || "")
//         .toLowerCase()
//         .includes(filters.bin_type_name.toLowerCase()) &&
//       statusText.includes(filters.status.toLowerCase())
//     );
//   });

//   setFilteredList(filtered);
// }, [filters, mappingList]);
useEffect(() => {
  const filtered = (mappingList || []).filter((row) => {
    // ✅ Normalize status (handles both boolean & string cases)
    const statusText =
      row.status === true ||
      (typeof row.status === "string" &&
        row.status.toLowerCase() === "active")
        ? "active"
        : "inactive";

    // ✅ Normalize filters to lowercase
    const fRegion = (filters.region || "").toLowerCase();
    const fPackageType = (filters.package_type || "").toLowerCase();
    const fWarehouse = (filters.warehouse_name || "").toLowerCase();
    const fBinType = (filters.bin_type_name || "").toLowerCase();
    const fStatus = (filters.status || "").toLowerCase();

    // ✅ Apply case-insensitive filtering
    return (
      (row.region || "").toLowerCase().includes(fRegion) &&
      (row.package_type || "").toLowerCase().includes(fPackageType) &&
      (row.warehouse_name || "").toLowerCase().includes(fWarehouse) &&
      (row.bin_type_name || "").toLowerCase().includes(fBinType) &&
      statusText.startsWith(fStatus)
    );
  });

  setFilteredList(filtered);
}, [filters, mappingList]);


  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleAdd = () => {
    setFormData({});
    setIsFormOpen(true);
  };

  const handleEdit = (row) => {
    const payload = {
      p_companyid: localStorage.getItem("companyid"),
      p_plantid: 1,
      p_mapping_id: row.warehouse_mapping_id,
    };

    callApi(
      Warehouse_API_ENDPOINTS.warehousemapping.list,
      "POST",
      { "Content-Type": "application/json" },
      payload
    )
      .then((data) => {
        if (data && data.length > 0) {
          setFormData(data[0]);
          setIsFormOpen(true);
        } else {
          setAlertSeverity("warning");
          setAlertTitle("Warning");
          setAlertMessage("No data found for selected Warehouse Mapping");
          setAlertOpen(true);
        }
      })
      .catch(() => {
        setAlertSeverity("error");
        setAlertTitle("Error");
        setAlertMessage("Failed to fetch Warehouse Mapping details");
        setAlertOpen(true);
      });
  };

  const handleExit = () => {
    handleBackWinderMachineEntry();
  };

  return (
    <Grid>
      {!isFormOpen && (
        <>
          <CssBaseline />
          <AppBar
            position="static"
            sx={{
              backgroundColor: "inherit",
              borderRadius: "0px",
              height: "48px",
              justifyContent: "center",
            }}
          >
            <Toolbar>
              {/* 🔽 Menu below Title */}
          <Box >
            <Button
              color="secondary"
              onClick={handleMenuClickFirst}
              endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
              sx={{
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 500,
              }}
            >
              {selectedOptionFirst}
            </Button>
            <Menu anchorEl={anchorElFirst} open={openFirst} onClose={handleMenuCloseFirst}>
              <MenuItem onClick={() => handleMenuItemClickFirst("All WH Mapping List")}>All Mapping List</MenuItem>
              <MenuItem onClick={() => handleMenuItemClickFirst("Active Mapping List")}>Active Mapping List</MenuItem>
              <MenuItem onClick={() => handleMenuItemClickFirst("Inactive Mapping List")}>
                Inactive Mapping List
              </MenuItem>
            </Menu>
          </Box>
{hasPermission(userPermissions, "Warehouse Mapping", "Create") && (
              <Button
                size="small"
                variant="contained"
                color="secondary"
                startIcon={<Warehouse />}
                sx={{ ml: "auto", textTransform: "none" }}
                onClick={handleAdd}
              >
                New Mapping
              </Button>
)}

 <Tooltip title="View help document details" arrow>
                <IconButton
                  size="small"
                  aria-label="help"
                  sx={{ mx: 1 }}
                  onClick={handleHelpMenuClick}
                >
                  <HelpIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Tooltip>
              
              
                                      <ModuleHelpDialog
                                          open={helpOpen}
                                          onClose={handleCloseHelp}
                                          data={moduleHelpData.WarehouseMappingMaster}
                                      />

              <IconButton onClick={handleExit}>
                <Close style={{ fontSize: "16px", color: "#2196F3" }} />
              </IconButton>
            </Toolbar>
          </AppBar>

         

          {/* Alerts */}
          <CallAlertBar
            parentRollMsgOpen={alertOpen}
            setParentRollMsgOpen={setAlertOpen}
            parentRollSeverityvalue={alertSeverity}
            setParentRollSeverityvalue={setAlertSeverity}
            parentRollAlertTitleValue={alertTitle}
            setParentRollAlertTitleValue={setAlertTitle}
            parentRollMessageValue={alertMessage}
            setParentRollMessageValue={setAlertMessage}
          />

          {/* Table */}
          <Grid container padding={1}>
            <Grid item xs={12}>
              <Box
                sx={{
                  "& .MuiTableCell-root": {
                    border: "1px solid",
                    borderColor: `${colors.primary[400]} !important`,
                    padding: "6px",
                  },
                  maxHeight: "75vh",
                  overflowY: "auto",
                }}
              >
                <TableContainer>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>Zone</TableCell>
                        <TableCell>Package Mode</TableCell>
                        <TableCell>Warehouse</TableCell>
                        <TableCell>Bin Type</TableCell>
                        <TableCell>Status</TableCell>
                      </TableRow>
                      {/* 🔍 Filter Row */}
                      <TableRow>
                        <TableCell>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder="Search..."
                            fullWidth
                            value={filters.region}
                            onChange={(e) => handleFilterChange("region", e.target.value)}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder="Search..."
                            fullWidth
                            value={filters.package_type}
                            onChange={(e) =>
                              handleFilterChange("package_type", e.target.value)
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder="Search..."
                            fullWidth
                            value={filters.warehouse_name}
                            onChange={(e) =>
                              handleFilterChange("warehouse_name", e.target.value)
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder="Search..."
                            fullWidth
                            value={filters.bin_type_name}
                            onChange={(e) =>
                              handleFilterChange("bin_type_name", e.target.value)
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder="Search..."
                            fullWidth
                            value={filters.status}
                            onChange={(e) => handleFilterChange("status", e.target.value)}
                          />
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {filteredList.map((row) => (
                        <TableRow key={row.warehouse_mapping_id}>
                          <TableCell
                            sx={{
                              color: "teal",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => handleEdit(row)}
                          >
                            {row.region}
                          </TableCell>
                          <TableCell>{row.package_type}</TableCell>
                          <TableCell>{row.warehouse_name}</TableCell>
                          <TableCell>{row.bin_type_name}</TableCell>
                          <TableCell>
                                  <Typography
                                    sx={{
                                      fontWeight: 600,
                                      color: row.status === true ? '' : '',
                                    }}
                                  >
                                    {row.status === true || row.status === 'Active'
                                      ? 'Active'
                                      : 'Inactive'}
                                  </Typography>
                                </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </>
      )}

      {/* Add / Edit Form */}
      {isFormOpen && (
        <AddUpdateWarehousemapping
          formData={formData}
          setFormData={setFormData}
          setIsFormOpen={setIsFormOpen}
          LoadWarehouseMappingList={loadWarehouseMappingList}
        />
      )}
    </Grid>
  );
};

export default WarehouseMappingMasterIndex;
